import {ScopeList} from 'Components/Widgets/Interfaces/WidgetData';
const checkFootprinting: (scopeData: ScopeList[]) => boolean = (scopeData) => {
  return scopeData.some((scope) => {
    return scope.emissionIntensity > 0;
  });
};

export default checkFootprinting;
